import axios from 'axios'
import { BUSCAR_OPCOES_FILTROS_EMISSOES_CTE_OS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarOpcoesFiltrosEmissaoesCteOs (empresaId) {

  const url = `${URL}/emissao-cte-os/opcoes-filtro/${empresaId}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_OPCOES_FILTROS_EMISSOES_CTE_OS,
        payload: response

      })
  );
}
